import { InputWrapper } from '@/core/components/InputWrapper';

interface FormInputProps {
  backgroundcolor: string;
  error: () => string | false;
  isDisabled?: boolean;
  isRequired?: boolean;
  onBlur?: () => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  label?: string;
  type?: string;
  value: string | number | undefined;
  maxlength?: number;
}

export const FormInput = ({
  backgroundcolor,
  error,
  isDisabled,
  isRequired,
  maxlength,
  name,
  onBlur,
  onChange,
  onFocus,
  label,
  type,
  value,
}: FormInputProps) => (
  <InputWrapper
    backgroundcolor={backgroundcolor}
    error={error}
    isRequired={isRequired}
  >
    <input
      disabled={isDisabled}
      type={type}
      name={name}
      placeholder=" "
      onBlur={() => {
        if (onBlur) {
          onBlur();
        }
      }}
      onChange={onChange}
      onFocus={onFocus}
      required={isRequired}
      value={value}
      maxLength={maxlength}
    />
    <span>{label}</span>
  </InputWrapper>
);

FormInput.defaultProps = {
  isDisabled: false,
  isRequired: false,
  label: '',
  maxlength: null,
  onBlur: () => null,
  onFocus: () => null,
  type: 'text',
};
